import React from 'react';
import './CGButton.scss';
import { Spin } from 'antd';

export type CGButtonType = 'primary' | 'default' | 'dashed' | 'text' | 'link' | 'submit';
export type CGButtonSize = 'small' | 'middle' | 'large';
export type CGButtonShape = 'default' | 'circle' | 'round';

export interface CGButtonProps {
  type?: CGButtonType;
  size?: CGButtonSize;
  shape?: CGButtonShape;
  icon?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  danger?: boolean;
  ghost?: boolean;
  block?: boolean;
  htmlType?: 'button' | 'submit' | 'reset';
  className?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
}

const CGButton: React.FC<CGButtonProps> = ({
  type = 'default',
  size = 'middle',
  shape = 'default',
  icon,
  loading = false,
  disabled = false,
  danger = false,
  ghost = false,
  block = false,
  htmlType = 'button',
  className = '',
  children,
  onClick,
  style,
  ...props
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (loading || disabled) return;
    onClick?.(event);
  };
  const buttonClasses = [
    'cg-btn',
    `cg-btn-${type}`,
    `cg-btn-${size}`,
    `cg-btn-${shape}`,
    danger && 'cg-btn-danger',
    ghost && 'cg-btn-ghost',
    block && 'cg-btn-block',
    loading && 'cg-btn-loading',
    disabled && 'cg-btn-disabled',
    className
  ]
    .filter(Boolean)
    .join(' ');
  const iconElement = loading ? <Spin size='small' /> : icon;

  return (
    <button
      type={htmlType}
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      style={style}
      {...props}
    >
      {iconElement && <span className={`cg-btn-icon ${children ? 'with-text' : 'icon-only'}`}>{iconElement}</span>}
      {children && <span className='cg-btn-text'>{children}</span>}
    </button>
  );
};

export default CGButton;
